





























































































































































































































import {
  PayrollChangeRequest,
  PayrollChangeRequestFieldError,
  IPayrollChangeRequest,
  User,
  EmployeeType
} from '@/models';

import { ALForm } from '@/common/component.types';

import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import { diffDeep } from '@/utils/helpers';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { mapActions } from 'vuex';
import DepartmentPicker from '../department/DepartmentPicker.vue';
import WorkgroupPicker from '../workgroup/WorkgroupPicker.vue';
import EmployeePicker from '../employee/EmployeePicker.vue';
import PayrollChangeRequestReasonPicker from './PayrollChangeRequestReasonPicker.vue';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import ALDialog from '../core/Dialog/ALDialog.vue';
import PayrollChangeRequestStatusDisplay from '../requisition-common/PayrollChangeRequestStatusDisplay.vue';
import { AxiosError } from 'axios';

const baseMixins = mixins(auth);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'PayrollChangeRequestDetailForm',

    components: {
      ErrorAlert,
      DepartmentPicker,
      WorkgroupPicker,
      EmployeePicker,
      PayrollChangeRequestReasonPicker,
      ALDialog,
      PayrollChangeRequestStatusDisplay
    },

    data() {
      return {
        dialog: false,
        payrollChangeRequestFormValid: false,
        isEdit: false,

        loading: false,
        departmentLoading: false,

        dateMenu: false,

        showCustomReasonField: false,
        reasonOptions: [
          'Temporary Transfer',
          'Bereavement',
          'Stat. Holiday (do not pay)',
          'Successful posting applicant',
          'Change in responsibilities',
          'Temporary recall',
          'Training',
          'Payroll Error',
          'Temporary group leader',
          'Temporary lead hand'
        ],

        payrollChangeRequest: null as IPayrollChangeRequest | null,
        payrollChangeRequestOriginalCopy: null as IPayrollChangeRequest | null,
        fieldError: new PayrollChangeRequestFieldError(),

        errorMessage: '',
        errorMessageDetail: '',
        EmployeeType
      };
    },

    computed: {
      authProvider(): any {
        return this.$altoleapAccounts.authProvider;
      },

      currentUser(): User {
        return this.authProvider.getCurrentUser;
      }
    },

    methods: {
      ...mapActions({
        createPayrollChangeRequest:
          'payrollChangeRequest/createPayrollChangeRequest',
        updatePayrollChangeRequest:
          'payrollChangeRequest/updatePayrollChangeRequest'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(
        payrollChangeRequest: IPayrollChangeRequest = new PayrollChangeRequest(),
        isEdit = false
      ) {
        this.payrollChangeRequestOriginalCopy = payrollChangeRequest;
        this.payrollChangeRequest = cloneDeep(
          this.payrollChangeRequestOriginalCopy
        );

        if (!isEdit) {
          this.showCustomReasonField = false;

          //assign current user as owner on create form
          this.payrollChangeRequest!.owner = new User(this.currentUser);
        } else {
          this.showCustomReasonField = this.payrollChangeRequest.reason
            ? !this.reasonOptions.includes(this.payrollChangeRequest.reason)
            : false;
        }

        this.isEdit = isEdit;
        this.clearAllErrors();
        this.dialog = true;

        this.resetFormValidation();
      },

      clearAllErrors(): void {
        this.fieldError.clearErrors();
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      close() {
        this.dialog = false;
      },

      formatDate(date: string): string {
        return date ? moment(date).format('MMMM D YYYY') : '';
      },

      async savePayrollChangeRequest(): Promise<void> {
        if (this.validateForm()) {
          this.clearAllErrors();

          this.loading = true;

          //TODO: MG-2022-08-23 Override v-select clear function to return string instead of null
          if (!this.payrollChangeRequest!.reason) {
            this.payrollChangeRequest!.reason = '';
          }

          try {
            if (this.isEdit) {
              const payrollChangeRequestDelta = diffDeep(
                this.payrollChangeRequest,
                this.payrollChangeRequestOriginalCopy,
                true
              );

              await this.updatePayrollChangeRequest(
                payrollChangeRequestDelta
              ).then(() => {
                this.$emit('genPayrollChangeRequest');
              });
            } else {
              await this.createPayrollChangeRequest(this.payrollChangeRequest);
            }

            this.loading = false;
            this.dialog = false;
          } catch (err) {
            this.loading = false;
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessage = error.response.data.detail;
              }
              // client received an error response that falls out of range 2xx
              if (
                PayrollChangeRequestFieldError.isPayrollChangeRequestFieldError(
                  error.response.data
                )
              ) {
                this.fieldError = new PayrollChangeRequestFieldError(
                  error.response.data
                );
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          }
        }
      }
    }
  });
